import {
  dashboard,
  edificio,
  espacio,
  menuicon08,
  menuicon09,
  reportes,
  sidemenu,
} from '../components/imagepath';

export const MODULES = {
  DASHBOARD: 'dashboard',
  INMUEBLES: 'inmuebles',
  ESPACIOS: 'espacios',
  INQUILINOS: 'inquilinos',
  CONTABILIDAD: 'contabilidad',
  CONTRATOS: 'contratos',
  REPORTES: 'reportes',
  CONFIGURACION: 'configuracion',
  USUARIOS: 'usuarios',
  MI_CONTRATO: 'mi_contrato',
  MIS_PAGOS: 'mis_pagos',
};

export const MODULE_LABELS = {
  [MODULES.DASHBOARD]: 'Dashboard',
  [MODULES.INMUEBLES]: 'Inmuebles',
  [MODULES.ESPACIOS]: 'Espacios',
  [MODULES.INQUILINOS]: 'Inquilinos',
  [MODULES.CONTABILIDAD]: 'Contabilidad',
  [MODULES.CONTRATOS]: 'Contratos',
  [MODULES.REPORTES]: 'Reportes',
  [MODULES.CONFIGURACION]: 'Configuración',
  [MODULES.USUARIOS]: 'Usuarios',
  [MODULES.MI_CONTRATO]: 'Mi contrato',
  [MODULES.MIS_PAGOS]: 'Mis pagos',
};

export const ALL_MODULES = Object.values(MODULES);

/** Permisos por defecto según rol (sincronizado con backend AppModule) */
export const ROLE_DEFAULT_PERMISSIONS = {
  administrador: Object.values(MODULES),
  propietario: [
    MODULES.DASHBOARD,
    MODULES.INMUEBLES,
    MODULES.ESPACIOS,
    MODULES.INQUILINOS,
    MODULES.CONTABILIDAD,
    MODULES.CONTRATOS,
    MODULES.REPORTES,
    MODULES.CONFIGURACION,
  ],
  operador: [
    MODULES.DASHBOARD,
    MODULES.ESPACIOS,
    MODULES.INQUILINOS,
    MODULES.CONTABILIDAD,
    MODULES.CONTRATOS,
    MODULES.CONFIGURACION,
  ],
  inquilino: [
    MODULES.MI_CONTRATO,
    MODULES.MIS_PAGOS,
    MODULES.CONFIGURACION,
  ],
};

/** Mapeo de rutas a módulo requerido */
export const ROUTE_MODULE_MAP = [
  { pattern: /^\/admin-dashboard/, module: MODULES.DASHBOARD },
  { pattern: /^\/inmueble/, module: MODULES.INMUEBLES },
  { pattern: /^\/inmuebles\//, module: MODULES.INMUEBLES },
  { pattern: /^\/espacios/, module: MODULES.ESPACIOS },
  { pattern: /^\/inquilinos/, module: MODULES.INQUILINOS },
  { pattern: /^\/contabilidad/, module: MODULES.CONTABILIDAD },
  { pattern: /^\/pagos/, module: MODULES.CONTABILIDAD },
  { pattern: /^\/gastos/, module: MODULES.CONTABILIDAD },
  { pattern: /^\/contrato/, module: MODULES.CONTRATOS },
  { pattern: /^\/reporte/, module: MODULES.REPORTES },
  { pattern: /^\/persona-registrar/, module: MODULES.USUARIOS },
  { pattern: /^\/usuarios-registros/, module: MODULES.USUARIOS },
  { pattern: /^\/mi-contrato/, module: MODULES.MI_CONTRATO },
  { pattern: /^\/mis-pagos/, module: MODULES.MIS_PAGOS },
  { pattern: /^\/conf-/, module: MODULES.CONFIGURACION },
  { pattern: /^\/perfil/, module: MODULES.CONFIGURACION },
  { pattern: /^\/editar-perfil/, module: MODULES.CONFIGURACION },
  { pattern: /^\/cuenta-configuracion/, module: MODULES.CONFIGURACION },
];

export const MENU_ITEMS = [
  {
    id: 'menu-item',
    submenuClass: 'menu-items',
    label: 'Dashboard',
    module: MODULES.DASHBOARD,
    icon: dashboard,
    iconType: 'img',
    children: [
      { label: 'Admin Dashboard', path: '/admin-dashboard', activeKey: 'admin-dashboard' },
    ],
  },
  {
    id: 'menu-item1',
    submenuClass: 'menu-items1',
    label: 'Inmuebles',
    module: MODULES.INMUEBLES,
    icon: edificio,
    iconType: 'img',
    iconClass: 'edificio-icon',
    children: [
      { label: 'Añadir Inmueble', path: '/inmueble-anadir', activeKey: 'inmueble-anadir' },
      { label: 'Registros Inmuebles', path: '/inmueble-registros', activeKey: 'inmueble-registros' },
    ],
  },
  {
    id: 'menu-item2',
    submenuClass: 'menu-items2',
    label: 'Espacios',
    module: MODULES.ESPACIOS,
    icon: espacio,
    iconType: 'img',
    children: [
      { label: 'Registrar Espacios', path: '/espacios-anadir', activeKey: 'espacios-registrar' },
      { label: 'Registros', path: '/espacios-registros', activeKey: 'espacios-registros' },
    ],
  },
  {
    id: 'menu-item3',
    submenuClass: 'menu-items3',
    label: 'Inquilinos',
    module: MODULES.INQUILINOS,
    icon: menuicon08,
    iconType: 'img',
    children: [
      { label: 'Registrar', path: '/inquilinos-registrar', activeKey: 'inquilinos-registrar' },
      { label: 'Registros', path: '/inquilinos-registros', activeKey: 'inquilinos-registros' },
    ],
  },
  {
    id: 'menu-item4',
    submenuClass: 'menu-items4',
    label: 'Contabilidad',
    module: MODULES.CONTABILIDAD,
    icon: sidemenu,
    iconType: 'img',
    children: [
      { label: 'Pagos', path: '/contabilidad-pagos', activeKey: 'contabilidad-pagos' },
      { label: 'Gastos', path: '/contabilidad-gastos', activeKey: 'contabilidad-gastos' },
    ],
  },
  {
    id: 'menu-item5',
    submenuClass: 'menu-items5',
    label: 'Contratos',
    module: MODULES.CONTRATOS,
    icon: menuicon09,
    iconType: 'img',
    children: [
      { label: 'Lista de contratos', path: '/contrato-registros', activeKey: 'contrato-registros' },
    ],
  },
  {
    id: 'menu-item6',
    submenuClass: 'menu-items6',
    label: 'Reportes',
    module: MODULES.REPORTES,
    icon: reportes,
    iconType: 'img',
    children: [
      { label: 'Reporte de gastos', path: '/reporte-gastos', activeKey: 'reporte-gastos' },
      { label: 'Reporte de pagos', path: '/reporte-pagos', activeKey: 'reporte-pagos' },
    ],
  },
  {
    id: 'menu-item7',
    submenuClass: 'menu-items7',
    label: 'Usuarios',
    module: MODULES.USUARIOS,
    iconType: 'fa',
    iconClass: 'fa-users',
    children: [
      {
        label: 'Listar usuarios',
        path: '/usuarios-registros',
        activeKey: 'usuarios-registros',
        module: MODULES.USUARIOS,
      },
      {
        label: 'Registrar Usuario',
        path: '/persona-registrar',
        activeKey: 'persona-registrar',
        module: MODULES.USUARIOS,
      },
    ],
  },
  {
    id: 'menu-item8',
    submenuClass: 'menu-items8',
    label: 'Mi portal',
    module: MODULES.MI_CONTRATO,
    iconType: 'fa',
    iconClass: 'fa-user-circle',
    children: [
      { label: 'Mi contrato', path: '/mi-contrato', activeKey: 'mi-contrato', module: MODULES.MI_CONTRATO },
      { label: 'Mis pagos', path: '/mis-pagos', activeKey: 'mis-pagos', module: MODULES.MIS_PAGOS },
    ],
  },
];

/** Palabras clave para abrir submenú según ruta activa */
export const ACTIVE_SUBMENU_KEYWORDS = [
  { keyword: 'admin-dashboard', submenu: 'Dashboard', menuId: 'menu-item', submenuClass: 'menu-items' },
  { keyword: 'inmueble-anadir', submenu: 'Inmuebles', menuId: 'menu-item1', submenuClass: 'menu-items1' },
  { keyword: 'inmueble-registros', submenu: 'Inmuebles', menuId: 'menu-item1', submenuClass: 'menu-items1' },
  { keyword: 'espacios-anadir', submenu: 'Espacios', menuId: 'menu-item2', submenuClass: 'menu-items2' },
  { keyword: 'espacios-registrar', submenu: 'Espacios', menuId: 'menu-item2', submenuClass: 'menu-items2' },
  { keyword: 'espacios-registros', submenu: 'Espacios', menuId: 'menu-item2', submenuClass: 'menu-items2' },
  { keyword: 'espacios-detalle', submenu: 'Espacios', menuId: 'menu-item2', submenuClass: 'menu-items2' },
  { keyword: 'inquilinos-registrar', submenu: 'Inquilinos', menuId: 'menu-item3', submenuClass: 'menu-items3' },
  { keyword: 'inquilinos-registros', submenu: 'Inquilinos', menuId: 'menu-item3', submenuClass: 'menu-items3' },
  { keyword: 'inquilinos-pago', submenu: 'Inquilinos', menuId: 'menu-item3', submenuClass: 'menu-items3' },
  { keyword: 'inquilinos-detalle', submenu: 'Inquilinos', menuId: 'menu-item3', submenuClass: 'menu-items3' },
  { keyword: 'contabilidad-gastos', submenu: 'Contabilidad', menuId: 'menu-item4', submenuClass: 'menu-items4' },
  { keyword: 'contabilidad-pagos', submenu: 'Contabilidad', menuId: 'menu-item4', submenuClass: 'menu-items4' },
  { keyword: 'contrato-generar', submenu: 'Contratos', menuId: 'menu-item5', submenuClass: 'menu-items5' },
  { keyword: 'contrato-registros', submenu: 'Contratos', menuId: 'menu-item5', submenuClass: 'menu-items5' },
  { keyword: 'reporte-pagos', submenu: 'Reportes', menuId: 'menu-item6', submenuClass: 'menu-items6' },
  { keyword: 'reporte-gastos', submenu: 'Reportes', menuId: 'menu-item6', submenuClass: 'menu-items6' },
  { keyword: 'usuarios-registros', submenu: 'Usuarios', menuId: 'menu-item7', submenuClass: 'menu-items7' },
  { keyword: 'persona-registrar', submenu: 'Usuarios', menuId: 'menu-item7', submenuClass: 'menu-items7' },
  { keyword: 'mi-contrato', submenu: 'Mi portal', menuId: 'menu-item8', submenuClass: 'menu-items8' },
  { keyword: 'mis-pagos', submenu: 'Mi portal', menuId: 'menu-item8', submenuClass: 'menu-items8' },
];

export const resolvePermissions = (user) => {
  if (!user) return [];
  if (Array.isArray(user.permisos) && user.permisos.length > 0) {
    return user.permisos;
  }
  const rol = String(user.rol || '').toLowerCase();
  return ROLE_DEFAULT_PERMISSIONS[rol] || [MODULES.CONFIGURACION];
};

export const getModuleForPath = (pathname) => {
  const match = ROUTE_MODULE_MAP.find(({ pattern }) => pattern.test(pathname));
  return match?.module ?? null;
};

export const getFirstAllowedPath = (permissions) => {
  for (const item of MENU_ITEMS) {
    if (!permissions.includes(item.module)) {
      const childModule = item.children?.find((c) => permissions.includes(c.module || item.module));
      if (!childModule) continue;
    }
    for (const child of item.children) {
      const childModule = child.module || item.module;
      if (permissions.includes(childModule)) {
        return child.path;
      }
    }
  }
  return '/conf-cambio-contrasena';
};
